import { KNOWN_SPONSORS } from './constants';

/** Return a known sponsor bucket name, or null to exclude the row. */
export const getSponsorBucket = (row) => {
  const template = String(row.EventTemplate || '').trim().toLowerCase();
  const sponsor  = String(row.Sponsor || '').trim().toLowerCase();
  const gfxType  = String(row['Graphic Type'] || '').trim().toLowerCase();

  if (template && KNOWN_SPONSORS[template]) return KNOWN_SPONSORS[template];
  if (sponsor && KNOWN_SPONSORS[sponsor]) return KNOWN_SPONSORS[sponsor];
  if (gfxType.includes('tournament logo')) return 'Tournament Logo';

  return null;
};

/** Get the date string from a row (handles multiple possible shapes). */
export const getRowDate = (row) => {
  const d = row.Date;
  if (!d) return null;
  if (typeof d === 'string' && d.length >= 10) return d.slice(0, 10);
  try {
    const parsed = new Date(d);
    if (!isNaN(parsed)) return parsed.toISOString().slice(0, 10);
  } catch { /* ignore */ }
  return String(d);
};

/** Format seconds as "Xh Ym" */
export const fmtHM = (seconds) => {
  if (!seconds || seconds <= 0) return '0h 0m';
  const h = Math.floor(seconds / 3600);
  const m = Math.round((seconds % 3600) / 60);
  return `${h}h ${m}m`;
};

/** Format a date string for the day dropdown */
export const formatDay = (dateStr) => {
  try {
    return new Date(dateStr + 'T00:00:00').toLocaleDateString(undefined, {
      weekday: 'short', year: 'numeric', month: 'short', day: 'numeric'
    });
  } catch {
    return dateStr;
  }
};
